import { Images } from '@/assets/images';
import { DocTypeEnum, REGEX } from '@/constant';
import { cn, dayjs, diffDate, formatDate } from '@/utils';

import { isNotNilOrEmpty } from 'ramda-adjunct';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	name: '',
	date: '',
	city: '',
	// position: '', // '시‧군',
	// position1: '', // '시장‧군수',
	totalDays: '',
	workPeriod1: [],
	workPeriod2: [],
	workPeriodStartDate1: '',
	workPeriodEndDate1: '',
	workPeriodStartDate2: '',
	workPeriodEndDate2: '',
	employer1: '',
	employer2: '',
	employerContact1: '',
	employerContact2: '',
	totalDaysWorked1: '',
	totalDaysWorked2: '',
	mayor: '',
	gender: '',
	national: '',
	birthDate: '',
	cityChina: '',
	cityEn: '',
	sealIdFilePath: '',
	contactNo1: '',
	contactNo2: '',
	contactNo3: '',
};

type IValues = typeof initializeValue;

export const PARTICIPATION_SEASONAL_WORK_CONFIG: FormConfig<
	IValues,
	DocTypeEnum.PM2_22
> = {
	initializeValue,
	title: '계절근로자 참여 확인서',
	mapPropToValues({ detailData, applicantData, lastedAssignment }) {
		const checkPeriodDate = (num: number) => {
			const workPeriodStartDate = lastedAssignment?.[num]?.workStartDate;
			const workPeriodEndDate = lastedAssignment?.[num]?.workEndDate;

			return {
				start: workPeriodStartDate || '',
				end: workPeriodEndDate || '',
				totalDays:
					workPeriodStartDate && workPeriodEndDate
						? `${diffDate(workPeriodEndDate, workPeriodStartDate) + 1}`
						: '0',
			};
		};

		const workPeriodDate1 = checkPeriodDate(0);

		const workPeriodDate2 = checkPeriodDate(1);

		const totalDays = isNotNilOrEmpty(lastedAssignment)
			? lastedAssignment?.reduce((total, assignment) => {
					const days =
						assignment?.workEndDate && assignment?.workStartDate
							? diffDate(assignment?.workEndDate, assignment?.workStartDate) + 1
							: 0;
					return total + days;
				}, 0)
			: 0;

		return {
			name: applicantData?.fullName || '',
			gender: applicantData?.genderName || '',
			birthDate: applicantData?.birthDate || '',
			national: applicantData?.nationalName || '',
			city: detailData?.unitInfo?.countyDistrict || '',
			cityEn: detailData?.unitInfo?.countyDistrict || '',
			cityChina: detailData?.unitInfo?.countyDistrict || '',
			mayor: detailData?.unitInfo?.countyDistrict || '',
			totalDays: `${totalDays}`,
			workPeriodStartDate1: workPeriodDate1.start,
			workPeriodEndDate1: workPeriodDate1.end,
			workPeriodStartDate2: workPeriodDate2.start,
			workPeriodEndDate2: workPeriodDate2.end,
			employer1: lastedAssignment?.[0]?.franchiseEmployerName || '',
			employer2: lastedAssignment?.[1]?.franchiseEmployerName || '',
			employerContact1: lastedAssignment?.[0]?.franchisePhone || '',
			employerContact2: lastedAssignment?.[1]?.franchisePhone || '',
			totalDaysWorked1: workPeriodDate1.totalDays,
			totalDaysWorked2: workPeriodDate2.totalDays,

			date: formatDate(dayjs()),
		};
	},
	pages: [
		{
			background: {
				src: Images.formParticipationSeasonalWork,
				className: 'template',
				dataSource: Images.formParticipationSeasonalWork,
			},
			textAreas: [
				{
					name: 'name',
					maxHeight: 48,
					maxLength: 40,
					containerClassName: 'absolute top-[237px] left-[260px] w-[210px]',
					className: 'text-[16px] leading-none',
				},
				{
					name: 'gender',
					maxHeight: 48,
					maxLength: 22,
					containerClassName: 'absolute top-[237px] right-[112px] w-[115px]',
					className: 'text-[17.33px] leading-none',
				},
				{
					name: 'national',
					maxHeight: 52,
					maxLength: 128,
					containerClassName: 'absolute top-[290px] right-[112px] w-[115px]',
					className: 'text-[17.33px] leading-none',
				},
				(values, index) => ({
					name: 'city',
					maxHeight: 36,
					maxLength: 8,
					className: 'text-center',
					containerClassName: cn(
						'absolute top-[353px] left-[183px] w-[72px] z-[1] items-end'
						// values?.city && 'bg-white'
					),
				}),
				// (values, index) => ({
				// 	name: 'position',
				// 	maxHeight: 24,
				// 	maxLength: 3,
				// 	className: 'text-[16px] text-center',
				// 	containerClassName: cn(
				// 		'absolute top-[413px] left-[243px] w-[43px]',
				// 		values?.city && 'bg-white'
				// 	),
				// 	readOnly: true,
				// }),
				(values, index) => ({
					name: 'totalDays',
					maxHeight: 20,
					maxLength: 3,
					className: 'text-center',
					containerClassName: cn(
						'absolute top-[370px] right-[181px] w-[26px] z-[1] items-end'
						// values?.totalDays && 'bg-white'
					),
				}),
				(values, index) => ({
					name: 'totalDays',
					maxHeight: 20,
					maxLength: 3,
					className: 'text-center',
					containerClassName: cn(
						'absolute top-[456px] right-[536px] w-[38px] z-[1] items-end'
						// values?.totalDays && 'bg-white'
					),
				}),

				{
					name: 'cityEn',
					maxHeight: 16,
					maxLength: 11,
					containerClassName: 'absolute top-[481px] left-[86px] w-[75px]',
				},
				(values, index) => ({
					name: 'cityChina',
					maxHeight: 36,
					maxLength: 8,
					className: 'text-center',
					containerClassName: cn(
						'absolute top-[498px] left-[210px] w-[51px] z-[1] items-end'
						// values?.city && 'bg-white'
					),
				}),
				(values, index) => ({
					name: 'totalDays',
					maxHeight: 20,
					maxLength: 3,
					className: 'text-center',
					containerClassName: cn(
						'absolute top-[540px] left-[239px] w-[48px] z-[1] items-end'
						// values?.totalDays && 'bg-white'
					),
				}),
				{
					name: 'employer1',
					maxHeight: 49,
					maxLength: 30,
					containerClassName: 'absolute bottom-[403px] left-[278px] w-[130px]',
					className: 'text-[17.33px] leading-none',
				},
				{
					name: 'employer2',
					maxHeight: 49,
					maxLength: 30,
					containerClassName: 'absolute bottom-[351px] left-[278px] w-[130px]',
					className: 'text-[17.33px] leading-none',
				},
				{
					name: 'employerContact1',
					maxHeight: 50,
					maxLength: 30,
					containerClassName: 'absolute bottom-[403px] left-[412px] w-[131px]',
					className: 'text-[17.33px] leading-none',
				},
				{
					name: 'employerContact2',
					maxHeight: 50,
					maxLength: 30,
					containerClassName: 'absolute bottom-[350px] left-[412px] w-[131px]',
					className: 'text-[17.33px] leading-none',
				},
				{
					name: 'totalDaysWorked1',
					maxHeight: 46,
					maxLength: 30,
					containerClassName: 'absolute bottom-[403px] left-[549px] w-[125px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					className: 'text-[17.33px] leading-none',
				},
				{
					name: 'totalDaysWorked2',
					maxHeight: 46,
					maxLength: 30,
					containerClassName: 'absolute bottom-[350px] left-[549px] w-[125px]',
					regex: REGEX.ALLOW_KR_EN_NUMBER_SPECIAL_CHARS,
					className: 'text-[17.33px] leading-none',
				},
				(values, index) => ({
					name: 'contactNo1',
					maxHeight: 20,
					maxLength: 4,
					containerClassName: 'absolute top-[920px] left-[73px] w-[40px] z-[1]',
					className: cn('text-[13px] text-center'),
					regex: REGEX.ALLOW_NUMBER,
				}),
				(values, index) => ({
					name: 'contactNo2',
					maxHeight: 20,
					maxLength: 4,
					containerClassName:
						'absolute top-[920px] left-[131px] w-[40px] z-[1]',
					className: cn('text-[13px] text-center'),
					regex: REGEX.ALLOW_NUMBER,
				}),
				(values, index) => ({
					name: 'contactNo3',
					maxHeight: 20,
					maxLength: 4,
					containerClassName:
						'absolute top-[920px] left-[192px] w-[40px] z-[1]',
					className: cn('text-[13px] text-center'),
					regex: REGEX.ALLOW_NUMBER,
				}),
			],
			rangePickers: [
				{
					name: ['workPeriodStartDate1', 'workPeriodEndDate1'],
					containerClassName:
						'absolute bottom-[415px] left-[84px] w-[195px] h-[24px] [&>.ant-picker-range>.ant-picker-input>input]:!text-[14px]',
				},
				{
					name: ['workPeriodStartDate2', 'workPeriodEndDate2'],
					containerClassName:
						'absolute bottom-[363px] left-[84px] w-[195px] h-[24px] [&>.ant-picker-range>.ant-picker-input>input]:!text-[14px]',
				},
			],
			datePickers: [
				{
					name: 'birthDate',
					containerClassName: 'absolute top-[306px] left-[263px]',
					className:
						'[&>.ant-picker-input>input]:!text-[14px] [&>.ant-picker-input>input]:text-left [&>.ant-picker-input>span.ant-picker-clear]:r-[10%] w-[207px]',
				},
				{
					name: 'date',
					segmentedInputs: true,
					containerClassName: 'absolute bottom-[328px] left-[170px] w-[416px]',
					format:
						'YYYY                                   MM                                          DD',
					style: { fontSize: '13px' },
					boxStyle: { marginBottom: '-17px' },
				},
				// (values, index) => ({
				// 	name: 'date',
				// 	className:
				// 		'[&>.ant-picker-input>input]:!text-[13px] [&>.ant-picker-input>.ant-picker-clear]:!translate-x-[-15px] [&>.ant-picker-input>.ant-picker-clear]:!translate-y-[-50%]',
				// 	containerClassName: cn(
				// 		'absolute bottom-[182px] left-[377px] w-[100px]',
				// 		values?.date && 'bg-[#FFF2B0]'
				// 	),
				// 	format: 'MM/DD/YYYY',
				// 	style: { marginBottom: '-17px', fontSize: '13px' },
				// }),
				// {
				// 	name: 'date',
				// 	className: '[&>.ant-picker-input>input]:!text-[13px]',
				// 	containerClassName: 'absolute bottom-[182px] left-[460px] w-[133px]',
				// 	format: 'YYYY      MM     DD',
				// 	style: { marginBottom: '-17px', fontSize: '13px' },
				// },
			],
			cachetForms: [
				{
					className: 'absolute top-[817px] left-[486px] w-[70px] h-[70px]',
				},
			],
			highlightBoxes: [
				{
					name: 'name',
					className: 'w-[50px] !h-[18px] top-[245px] left-[142px]',
				},
				{
					name: 'gender',
					className: 'w-[36px] !h-[18px] top-[239px] left-[502px]',
				},
				{
					name: 'birthDate',
					className: 'w-[165px] !h-[18px] top-[288px] left-[85px]',
				},
				{
					name: 'national',
					className: 'w-[37px] !h-[18px] top-[293px] left-[501px]',
				},
				// {
				// 	name: 'workPeriod',
				// 	className: 'w-[80px] !h-[18px] top-[485px] left-[79px]',
				// },
				// {
				// 	name: 'participation',
				// 	className: 'w-[65px] !h-[18px] top-[478px] left-[487px]',
				// },
				// {
				// 	name: 'workplace',
				// 	className: 'w-[134px] !h-[20px] top-[539px] left-[53px]',
				// },
				{
					name: 'city',
					className: 'w-[72px] !h-[18px] top-[368px] left-[183px]',
				},
				{
					name: 'city',
					className: 'w-[80px] !h-[18px] top-[479px] left-[83px]',
				},
				{
					name: 'city',
					className: 'w-[51px] !h-[18px] top-[514px] left-[211px]',
				},
				{
					name: 'totalDays',
					className: 'w-[26px] !h-[18px] top-[370px] left-[587px]',
				},
				{
					name: 'totalDays',
					className: 'w-[38px] !h-[18px] top-[456px] left-[220px]',
				},
				{
					name: 'totalDays',
					className: 'w-[46px] !h-[18px] top-[540px] left-[239px]',
				},
				{
					name: 'workPeriod1',
					className: 'w-[62px] !h-[18px] top-[620px] left-[145px]',
				},
				{
					name: 'employer1',
					className: 'w-[53px] !h-[18px] top-[620px] left-[319px]',
				},
				{
					name: 'employerContact1',
					className: 'w-[102px] !h-[18px] top-[620px] left-[430px]',
				},
				{
					name: 'totalDaysWorked1',
					className: 'w-[62px] !h-[18px] top-[615px] left-[582px]',
				},
				{
					name: 'date',
					className: 'w-[430px] !h-[27px] top-[790px] left-[155px]',
				},
				// {
				// 	name: 'mayor',
				// 	className: 'w-[85px] !h-[20px] top-[970px] left-[243px]',
				// },
				{
					name: 'sealIdFilePath',
					className: 'w-[30px] !h-[20px] top-[841px] left-[392px]',
				},
				{
					name: 'contactNo1',
					className: 'w-[40px] !h-[20px] top-[920px] left-[73px]',
				},
				{
					name: 'contactNo2',
					className: 'w-[40px] !h-[20px] top-[920px] left-[131px]',
				},
				{
					name: 'contactNo3',
					className: 'w-[40px] !h-[20px] top-[920px] left-[192px]',
				},
			],
		},
	],
};
